module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.isVersioning) ? _c('div', {
    staticClass: "version-ing"
  }, [_c('p', {
    staticClass: "fwbd mt20"
  }, [_vm._v("重庆众安小额贷款有限公司是一家经中国政府批准的，具备合法合规金融资质的公司，我们始终遵循国家法律政策，为广大用户提供放心，便捷的服务。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd mt20"
  }, [_vm._v("“点点”是重庆众安小额贷款有限公司旗下独立研发、运营的的一款金融产品，版权为重庆众安小额贷款有限公司所有。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd mt20"
  }, [_vm._v("Copyright ©2017众安小贷®版权所有")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd mt20"
  }, [_vm._v("All rights reserved")])]) : _vm._e(), _vm._v(" "), (!_vm.isVersioning) ? _c('div', {
    staticClass: "about-detail"
  }, [_vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "ad-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "ad-box mt-f ab-1"
  }, [_c('div', {
    staticClass: "ad-title"
  }, [_vm._v("关于点点")]), _vm._v(" "), _c('p', {
    staticClass: "ad-mt"
  }, [_c('b', [_vm._v("·点点")]), _vm._v("，国内领先的智能生活金融服务平台，旨为中国消费者提供最优质的综合生活与金融连接服务，已与国内众多知名金融机构达成深度合作。")])]), _vm._v(" "), _c('div', {
    staticClass: "ad-box ab-2 mt-25"
  }, [_c('div', {
    staticClass: "ad-title"
  }, [_vm._v("了解点点")]), _vm._v(" "), _c('ul', {
    staticClass: "ad-info"
  }, [_c('li', [_c('div', {
    staticClass: "ad-icon"
  }, [_c('div', {
    staticClass: "ad-pic"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ad-test"
  }, [_c('h2', [_vm._v("方便一点")]), _vm._v(" "), _c('p', [_vm._v("额度最高至20万，日费率低至0.025%起，极速审核，为应急解忧")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ad-icon"
  }, [_c('div', {
    staticClass: "ad-pic"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ad-test"
  }, [_c('h2', [_vm._v("安全一点")]), _vm._v(" "), _c('p', [_vm._v("已与国内众多知名机构深度合作")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ad-icon"
  }, [_c('div', {
    staticClass: "ad-pic"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ad-test"
  }, [_c('h2', [_vm._v("品质一点")]), _vm._v(" "), _c('p', [_vm._v("精选稀缺商品、分期免息买好物,助力品质生活")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ad-icon"
  }, [_c('div', {
    staticClass: "ad-pic"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ad-test"
  }, [_c('h2', [_vm._v("实惠一点")]), _vm._v(" "), _c('p', [_vm._v("各类优惠券、免息券拿到手软,积分兑换、促销活动天天办")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ad-icon"
  }, [_c('div', {
    staticClass: "ad-pic"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ad-test"
  }, [_c('h2', [_vm._v("丰富一点")]), _vm._v(" "), _c('p', [_vm._v("可还信用卡、可线下消费,想你所想一站式服务")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ad-icon"
  }, [_c('div', {
    staticClass: "ad-pic"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ad-test"
  }, [_c('h2', [_vm._v("便利一点")]), _vm._v(" "), _c('p', [_vm._v("充值缴费、看电影……足不出户便利生活")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ad-footer mt-20"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a45d796"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/aboutdetail.vue
// module id = 188
// module chunks = 0